Messages.FormView = function () {
  function FormView(data, success) {
    this.data = data;
    this.success = success;
    this.placeholder = this.data.placeholder || "Write a message";
  }
  FormView.prototype.render = function () {
    return JST["messages/templates/form"](this.data);
  };
  FormView.prototype.after_render = function (container) {
    var body, button, errorText, form;
    form = container.find(".new_message");
    button = form.find(".submit-reply-button");
    body = form.find("textarea");
    errorText = form.find(".js-error-text");
    body.attr('placeholder', this.placeholder);
    body.autosize({
      callback: function () {
        return form.trigger("resize_modal");
      }
    });
    if (!this.data.message_thread_id) {
      new Messages.RecipientFinder(form.find(".recipient-input"));
    }
    return button.on("click", function (_this) {
      return function (e) {
        e.preventDefault();
        errorText.text("");
        button.button('loading');
        return Messages.send_message({
          data: form.serialize()
        }).always(function () {
          return button.button('reset');
        }).done(function () {
          return typeof _this.success === "function" ? _this.success.apply(_this, arguments) : void 0;
        }).error(function (xhr) {
          var error, errors, response;
          response = JSON.parse(xhr.responseText);
          if (response.errors) {
            errors = $a.errors_array(response.errors);
            error = errors[0];
          }
          if (!error) {
            error = "Sorry, an error occurred. Please try again.";
          }
          return errorText.text(error);
        });
      };
    }(this));
  };
  return FormView;
}();